/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fields: NonNullable<unknown> }} Case_Validation_Fill_In_FieldsInputs */

const en_case_validation_fill_in_fields = /** @type {(inputs: Case_Validation_Fill_In_FieldsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Please fill in: ${i?.fields}.`)
};

const pt_br2_case_validation_fill_in_fields = /** @type {(inputs: Case_Validation_Fill_In_FieldsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Por favor, preencha: ${i?.fields}.`)
};

/**
* | output |
* | --- |
* | "Please fill in: {fields}." |
*
* @param {Case_Validation_Fill_In_FieldsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_fill_in_fields = /** @type {((inputs: Case_Validation_Fill_In_FieldsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Fill_In_FieldsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_fill_in_fields(inputs)
	return pt_br2_case_validation_fill_in_fields(inputs)
});